// @flow
import { put } from 'redux-saga/effects';
import { saveAs } from 'file-saver';
import moment from 'moment';
import { type Options } from '../components/DropdownInput';
import { getRequest, handleSagaError } from '../utilities/requests';

export const arrayToOptions = (
  array: Array<any>,
  textKey: string,
  valueKey: string,
  options: { allowBlank?: boolean, blankLabel?: string } = {
    allowBlank: true,
    blankLabel: ''
  }
) => {
  const result: Array<Options> = array.map(group => ({
    text: group[textKey],
    value: group[valueKey]
  }));
  if (options.allowBlank || options.blankLabel) {
    result.unshift({ text: options.blankLabel || '', value: '' });
  }
  return result;
};

export const dig = (baseCase: {}, ...arg: Array<any>) => {
  for (let i = 0; i < arg.length; i++) {
    if (i + 1 === arg.length) {
      return (baseCase || {})[arg[i]];
    }
    baseCase = (baseCase || {})[arg[i]];
  }
};

export const formatDate = (date: string) => moment(date).format('MM/DD/YY');

export function* downloadCsv(
  path: string,
  fileType: string,
  config: {}
): Generator<*, *, *> {
  try {
    if (!fileType) fileType = path;
    const url = `/${path}.csv`;
    const response = yield getRequest(url, config, { responseType: 'blob' });
    const time = moment().format('Y-MM-D');
    saveAs(response.data, `${path}-${time}.csv`);
  } catch (error) {
    yield handleSagaError(
      error,
      `Unable to download ${fileType} at this time. Please try again later.`
    );
  }
}

export function* calculatePagination(
  dataSetTotal: number,
  perPage: number,
  setTotal: Function
): Generator<*, *, *> {
  if (dataSetTotal > perPage) {
    const unRoundedTotal = dataSetTotal / perPage;
    const totalPages = Math.ceil(unRoundedTotal);
    yield put(setTotal(totalPages));
  } else {
    yield put(setTotal(1));
  }
}

export function orderBy(orderBy: string | null, orderByState: number) {
  let orderDirection = null;
  switch (orderByState) {
    case 0:
      orderBy = null;
      break;
    case 1:
      orderDirection = 'desc';
      break;
    case 2:
      orderDirection = 'asc';
      break;
    default:
      break;
  }
  return { order_by: orderBy, order_direction: orderDirection };
}
